export default {
    'list.nomore': 'no more'
}